export default {
    meta: {
        app: {
            title: "Eudonet Template",
        },
        home: {
            title: "Home - Eudonet"
        }
    },
    header:{
        title:"Eudonet",
        lang:{
            fr:"fr",
            en:"en"
        },
    },
    home:{
        title: "Eudonet Specific",
        subtitle: "This page must be personalized",
    },
    articles: {
        vuejs: {
            title: "Resources on VueJs",
        },  
        normes:{
            title: "Development guidelines",
        }
    },
    footer: {
        titre: "Power by",
        editor: {
            name: "Eudonet",
            url: "https://en.eudonet.com"
        },
    }
}